import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {TASK_ACTIONS, DETAILS_VIEW_TYPE, LOADING_STATUS} from 'utils/constants';
import {connect} from 'react-redux';
import {taskAction} from '../mytasks/action/taskAction.action';
import {navigateBetweenHistoryTasks} from '../mytasks/action/navigateBetweenTasks.action';
import {
    getHistoryTasksForRender,
    getTaskDetails,
    getTaskAttachments,
    getAttachmentsLoadingStatus
} from '../store/application.reducers';
import {TaskDetailActions} from '../mytasks/AvailableActions.class';
import {
    getProcessAndHistoryComments,
    getProcessByUID,
    getHistoryTaskDetailsWithPermissions,
    handleAddProcessAndHistoryDraftCommentsByUID,
} from "../taskdetails-remake/taskDetails.action";
import {formatTaskDetailsTopBanner} from 'utils/valueFormatter.function';
import {handleNPKeyNavigation} from 'utils/keyPressHandler.function';
import {preventDataReload} from '../myhistory/myHistory.action';
import _ from 'lodash';
import TaskDetails from 'components/taskdetails-remake/TaskDetails.component';
import {PATH_TO_MY_HISTORY} from "components/router/paths.js";
import { Loader, LoaderSize } from "components/common/Loader.component.tsx";
import {PanelErrorFallback} from "components/errorpage/PanelErrorBoundary";


const cl = class TaskDetailMasterLayer extends Component {
    constructor(props) {
        super(props);

        this.getActionsForTask = this.getActionsForTask.bind(this);
        this.getTaskDetailFromStore = this.getTaskDetailFromStore.bind(this);
        this.requestData = this.requestData.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.getNavigation = this.getNavigation.bind(this);
        this.navigateBack = this.navigateBack.bind(this);
        this.navigateBetweenTasks = this.navigateBetweenTasks.bind(this);
    }

    /*
     * default view is the attachemnts page so we need to get the attachemnts first
     * */
    componentDidMount() {
        // detail of current task is also in the store (use #getTaskDetailFromStore), but without for example the attachments, so we have to load it again

        const task = this.getTaskDetailFromStore();
        // an empty history list (session expiry, company switch, deep link) has no row to read the uid from (AC-12313)
        if (task) {
            this.requestData(task.uid);
        }
        document.addEventListener('keydown', this.handleKeyPress);
    }

    //this is needed to reload data at navigate between tasks with ctrl+alt+n
    componentDidUpdate(prevProps) {
        if (prevProps.match.params.taskId !== this.props.match.params.taskId) {
            this.requestData(this.props.match.params.taskId);
            return;
        }

        const task = this.getTaskDetailFromStore();
        // the row can land after mount, once the history list repopulates, and mount had no uid to request with (AC-12313)
        if (task && !this.getTaskDetailFromStore(prevProps)) {
            this.requestData(task.uid);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    navigateBetweenTasks(taskId, isForward) {
        this.props.history(this.props.navigateBetweenHistoryTasks(taskId, isForward));
    }


    handleKeyPress(e) {
        handleNPKeyNavigation(e, this.props.match.params.taskId, this.navigateBetweenTasks);
    }

    requestData(processUid) {
        this.props.getHistoryTaskDetailsWithPermissions(processUid);
    }


    getTaskDetailFromStore(props = this.props) {
        const thisTaskArray = (props.tasks.allTasks || []).filter(task => {
            return task.key === props.match.params.taskId
        });
        return thisTaskArray[0];
    }

    getActionsForTask(navigation) {
        let activeActions = new TaskDetailActions();

        // add email
        activeActions.enable(TASK_ACTIONS.EMAIL);

        //check if move actions are available
        if (navigation.currentTask !== navigation.total) {
            //enable move to next
            activeActions.enable(TASK_ACTIONS.NEXT_TASK);
        }
        if (navigation.currentTask !== 1) {
            activeActions.enable(TASK_ACTIONS.PREVIOUS_TASK);
        }
        return activeActions;
    }

    getNavigation(task) {
        //fill in all the data found in the task
        let response = formatTaskDetailsTopBanner(task, true);
        if (task) {
            response.companyName = task.companyName;
            //task number and number of selected tasks still need to be computed
            response.currentTask = _.findIndex(this.props.tasks.allTasks, (x => {
                return x.key === task.key;
            })) + 1;
        }
        response.total = this.props.tasks.allTasks.length;
        //response.isProcess = true;
        return response;
    }


    navigateBack() {
        this.props.preventDataReload(true);
    }


    render() {
        const task = this.getTaskDetailFromStore();

        // a failed load leaves no task to render, so the spinner below would never resolve (AC-12773)
        if (this.props.loadingStatus === LOADING_STATUS.ERROR)
            return <PanelErrorFallback/>;

         if (!task) {
            return <div className="position-fixed top-50 w-100">
                    <Loader size={LoaderSize.Medium} />
            </div>;
        }

        let navigation = this.getNavigation(task);
        const activeActions = this.getActionsForTask(navigation);
        let params = {
            taskId: this.props.match.params.taskId
        }

        return (
            <TaskDetails params={params}
                         task={task}
                         taskAction={this.props.taskAction}
                         attachments={this.props.attachments}
                         loadingStatus={this.props.loadingStatus}
                         taskDetails={this.props.taskDetails}
                         navigation={navigation}
                         route={this.props.route}
                         navigateBetweenTasks={this.props.navigateBetweenHistoryTasks}
                         activeActions={activeActions}
                         navigateBack={this.navigateBack}
                         isHistory={true}
                         navigateBackPath={PATH_TO_MY_HISTORY}
                         routerBlocker={this.props.blocker}
                         type={DETAILS_VIEW_TYPE.HISTORY_TASK}
                         allowActionlessComments = {this.props.taskDetails?.allowExtraComments}
                         addCommentHandler={this.props.handleAddProcessAndHistoryDraftCommentsByUID}
                         getCommentsHandler={this.props.getProcessAndHistoryComments}
            />
        );
    }
}

cl.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object,
    }),
    route: PropTypes.object,
    blocker: PropTypes.object,
    history: PropTypes.func,
    loadingStatus: PropTypes.number,
    taskDetails: PropTypes.shape({
        allowExtraComments: PropTypes.bool,
    }),
};

const mapStateToProps = function (store) {
    return {
        tasks: getHistoryTasksForRender(store),
        taskDetails: getTaskDetails(store),
        attachments: getTaskAttachments(store),
        loadingStatus: getAttachmentsLoadingStatus(store)
    };
};

const connected = connect(mapStateToProps, {
    taskAction,
    preventDataReload,
    navigateBetweenHistoryTasks,
    getHistoryTaskDetailsWithPermissions,
    getProcessByUID,
    handleAddProcessAndHistoryDraftCommentsByUID,
    getProcessAndHistoryComments,
})(cl);

export default connected;
